import React from 'react';
import { RouteComponentProps, withRouter } from 'react-router';
import Layout from '../../../../components/Layout/Layout';
import { Flex } from 'rebass';
import Makes from './Makes';
import Models from './Models';

type MakeDetailParams = {
  id?: string;
};

type MakeDetailProps = RouteComponentProps<MakeDetailParams>;

/**
 * @component Used for makes and models page
 */
function MakesAndModels({ match }: MakeDetailProps): JSX.Element {
  return (
    <Layout>
      <Flex px="mainContent" pb="mainContent" flexGrow={1}>
        <Flex width={380} maxWidth="50%" pr={2}>
          <Makes makeId={match.params.id} />
        </Flex>
        <Flex width={600} maxWidth="50%" pl={2}>
          <Models makeId={match.params.id} />
        </Flex>
      </Flex>
    </Layout>
  );
}

export default withRouter(MakesAndModels);
